import { render, staticRenderFns } from "./BannerUpload.vue?vue&type=template&id=f679541c&scoped=true&"
import script from "./BannerUpload.vue?vue&type=script&lang=js&"
export * from "./BannerUpload.vue?vue&type=script&lang=js&"
import style0 from "./BannerUpload.vue?vue&type=style&index=0&id=f679541c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f679541c",
  null
  
)

export default component.exports